import { Tooltip as Tip, TooltipProps as TipProps } from '@chakra-ui/react'
import React, { ReactElement } from 'react'

import { LogValue } from '../../model/orderLog.model'
export interface TooltipProps extends TipProps {
  label: ReactElement | LogValue
}

export const Tooltip: React.FC<TooltipProps> = ({ label = '', ...props }) => {
  return (
    <Tip
      shouldWrapChildren
      bg="neutral.90"
      data-testid="tooltip"
      fontSize="sm"
      label={label}
      maxWidth={200}
      p={3}
      placement={props.hasArrow ? 'top' : 'bottom'}
      {...props}
    />
  )
}
